module.exports = __webpack_public_path__ + "static/media/disabledDashboardIcon.46ada65d.svg";